import AccountCareRecipientsNewViewController from "./account-care-recipients-new-view-controller";
import AccountEmergencyContactEditViewController from "./emergency-contact-controller";
import AccountProfileEditViewController from "./account-profile-edit-view-controller";
import AboutYouEditViewController from "./unified_profile/about-you-edit-view-controller";
import AddressEditViewController from "./unified_profile/address-edit-view-controller";
import BasicProfileViewController from "./unified_profile/basic-profile-view-controller";
import ActivationDependentInfoViewController from "./activation-dependent-info-view-controller";
import AdvanceMedicalAddDependentConfirmationViewController from "./advance-medical-adc-view-controller";
import AdvanceMedicalAddDependentViewController from "./advance-medical-add-dependent-view-controller";
import AdvanceMedicalAppointmentVideoScheduleViewController from "./advance-medical-avs-view-controller";
import AdvanceMedicalDashboardViewController from "./advance-medical-dashboard-view-controller";
import AdvanceMedicalAppointmentListViewController from "./advance-medical-appointment-list-view-controller";
import BaseViewController from "./base-view-controller";
import BiometricsViewController from "./unified_profile/biometrics-view-controller";
import BhIntakeViewController from "./bh-intake-view-controller";
import CarePlanDetailsViewController from "./care-plan-details-view-controller";
import CareTeamProfileDetailController from "./care-team-profile-detail-controller";
import ConsultationBhScheduleViewController from "./consultation-bh-schedule-view-controller";
import ConsultationConfirmationViewController from "./consultation-confirmation-view-controller";
import ConsultationContactInfo from "./consultation-contact-info";
import ConsultationEditViewController from "./consultation-edit-view-controller";
import ConsultationImagesPcp from "./consultation-images-pcp";
import ConsultationPaymentCardEntry from "./consultation-payment-card-entry";
import ConsultationSchedulePhoneViewController from "./consultation-schedule-phone-view-controller";
import ConsultationNutritionAssessmentThreeViewController from "./consultation-nutrition-assessment-3-view-controller";
import ConsultationPhotoModalViewController from "./consultation-photo-modal-view-controller";
import ConsultationScheduleViewController from "./consultation-schedule-view-controller";
import ConsultationSuccessViewController from "./consultation-success-view-controller";
import ConsultationVpcAssessmentOneViewController from "./consultation-vpc-assessment-one-view-controller";
import ConsultSearchViewController from "./consult-search-view-controller";
import CoverageAndBillingViewController from "./unified_profile/coverage-and-billing-view-controller";
import CreditCardController from "./credit-card-controller";
import DetailViewController from "./detail-view-controller";
import EliteDiagnosticImagingServicePhotoModalViewController from "./edi-service-photo-modal-view-controller";
import EmoCasePhotoModalViewController from "./emo-case-photo-modal-view-controller";
import EnhancedSchedulingProviderFilterViewController from "./enhanced-scheduling-provider-filter-view-controller";
import ExpertMedicalOpinionOnlyAdultViewController from "./emo-only-adult-view-controller";
import FinalScreenViewController from "./final-screen-view-controller";
import FilterViewController from "./filter-view-controller";
import LanguageMenuViewController from "./unified_profile/language-menu-view-controller";
import ManualPharmacyViewController from "./manual-pharmacy-view-controller";
import NewProviderListViewController from "./new-provider-list-view-controller";
import PaymentScreenViewController from "./payment-screen-view-controller";
import PasswordScreenViewController from "./unified_profile/password-screen-view-controller";
import PharmacyMapViewController from "./pharmacy-map-view-controller";
import PharmacySearchViewController from "./pharmacy-search-view-controller";
import PhotoModalViewController from "./photo-modal-view-controller";
import ProviderListViewController from "./provider-list-view-controller";
import CareTeamMembersListController from "./care-team-members-list-controller";
import VideoRoomViewController from "./video-room-view-controller";
import MessageCenterListViewController from "./message-center-list-view-controller";
import MessageCenterDetailViewController from "./message-center-detail-view-controller";
import MessageCenterBhScheduleViewController from "./message-center-bh-schedule-view-controller";
import ConsultationDermIntakeViewController from "./consultation-derm-intake-view-controller";
import SearchTreatmentViewController from "./search-treatment-view-controller";
import AddTreatmentViewController from "./add-treatment-view-controller";
import AuthorizedConsentersListViewController from "./authorized-consenters-list-view-controller";
import AuthorizedConsenterEditViewController from "./authorized-consenter-edit-view-controller";
import AuthorizedConsenterNewViewController from "./authorized-consenter-new-view-controller";
import DoctorsListViewController from "./doctors-list-view-controller";
import DoctorEditViewController from "./doctor-edit-view-controller";
import DoctorNewViewController from "./doctor-new-view-controller";
import DoctorDetailViewController from "./doctor-detail-view-controller";
import PharmacyListViewController from "./pharmacy-list-view-controller";
import PharmacyDetailViewController from "./pharmacy-detail-view-controller";
import MedicalHistoryViewController from "./medical-history-view-controller";
import MentalHealthNavigatorCasePhotoModalViewController from "./mh-navigator-case-photo-modal-view-controller";
import SearchMedicationViewController from "./search-medication-view-controller";
import RecoverUsernameViewController from "./recover-username-view-controller";
import ForgotPasswordViewController from "./forgot-password-view-controller";
import AddMedicationViewController from "./add-medication-view-controller";
import ConsultationListViewController from "./consultation-list-view-controller";
import ConsultationDetailViewController from "./consultation-detail-view-controller";
import SectionedListViewController from "./sectioned-list-view-controller";
import NewPharmacyViewController from "./new-pharmacy-view-controller";
import SearchAllergyViewController from "./search-allergy-view-controller";
import AddAllergyViewController from "./add-allergy-view-controller";
import ImagesListViewController from "./images-list-view-controller";
import MessageCenterReplyViewController from "./message-center-reply-view-controller";
import AccountInvoicesListViewController from "./account-invoices-list-view-controller";
import ListViewController from "./list-view-controller";
import FilesListViewController from "./files-list-view-controller";
import TemplatedListViewController from "./templated-list-view-controller";
import PliMembersViewController from "./pli-members-view-controller";
import PharmacyMapTemplatedViewController from "./pharmacy-map-templated-view-controller";
import PreferredPharmacySearchViewController from "./preferred-pharmacy-search-view-controller";
import PharmacySearchV2ViewController from "./pharmacy-search-v2-view-controller";
import PulseConsultationPhotoModalViewController from "./pulse-consultation-photo-modal-view-controller";
import SecureYourAccountViewController from "./secure-your-account-view-controller";
import UploadImagesViewController from "./upload-images-view-controller";
import VisitMhMinorConsentViewController from "./visit-mh-minor-consent-view-controller";
import VisitUscStudyAttestationViewController from "./visit-usc-study-attestation-view-controller";
import MyPharmaciesViewController from "./my-pharmacies-view-controller";
import PharmacyResultTypesViewController from "./pharmacy-result-types-view-controller";
import ActivationAccountViewController from "./activation-account-view-controller";
import MinorMhIntakeCustomViewController from "./minor-mh-intake-custom-view-controller";
import AccountBillingEditViewController from "./unified_profile/account-billing-edit-view-controller";
import SigninSecurityPreferencesViewController from "./unified_profile/signin-security-preferences-view-controller";
import EmergencyContactViewController from "./unified_profile/emergency-contact-view-controller";
import FamilyViewController from "./unified_profile/family-view-controller";
import SetHighBloodSugarThresholdViewController from "./unified_profile/set-high-blood-sugar-threshold-view-controller";
import SetLowBloodSugarThresholdViewController from "./unified_profile/set-low-blood-sugar-threshold-view-controller";
import LowBloodSugarThresholdViewController from "./unified_profile/low-blood-sugar-threshold-view-controller";
import HighBloodSugarThresholdViewController from "./unified_profile/high-blood-sugar-threshold-view-controller";
import DoNotDisturbHoursViewController from "./unified_profile/do-not-disturb-hours-view-controller";

export default {
  AboutYouEditViewController,
  AccountCareRecipientsNewViewController,
  AccountEmergencyContactEditViewController,
  AccountBillingEditViewController,
  AccountProfileEditViewController,
  AddressEditViewController,
  ActivationDependentInfoViewController,
  AdvanceMedicalAddDependentConfirmationViewController,
  AdvanceMedicalAddDependentViewController,
  AdvanceMedicalDashboardViewController,
  AdvanceMedicalAppointmentListViewController,
  AdvanceMedicalAppointmentVideoScheduleViewController,
  BaseViewController,
  BasicProfileViewController,
  BiometricsViewController,
  BhIntakeViewController,
  CarePlanDetailsViewController,
  CareTeamProfileDetailController,
  ConsultationBhScheduleViewController,
  ConsultationConfirmationViewController,
  ConsultationContactInfo,
  ConsultationEditViewController,
  ConsultationImagesPcp,
  ConsultationNutritionAssessmentThreeViewController,
  ConsultationPaymentCardEntry,
  ConsultationSchedulePhoneViewController,
  ConsultationPhotoModalViewController,
  ConsultationSuccessViewController,
  ConsultationScheduleViewController,
  ConsultSearchViewController,
  CoverageAndBillingViewController,
  ConsultationVpcAssessmentOneViewController,
  CreditCardController,
  DetailViewController,
  EliteDiagnosticImagingServicePhotoModalViewController,
  EmoCasePhotoModalViewController,
  EnhancedSchedulingProviderFilterViewController,
  ExpertMedicalOpinionOnlyAdultViewController,
  FinalScreenViewController,
  FilterViewController,
  LanguageMenuViewController,
  ManualPharmacyViewController,
  MentalHealthNavigatorCasePhotoModalViewController,
  NewProviderListViewController,
  PasswordScreenViewController,
  PaymentScreenViewController,
  PharmacyMapViewController,
  PharmacySearchViewController,
  PhotoModalViewController,
  ProviderListViewController,
  CareTeamMembersListController,
  VideoRoomViewController,
  MessageCenterListViewController,
  MessageCenterDetailViewController,
  ConsultationDermIntakeViewController,
  SearchTreatmentViewController,
  AddTreatmentViewController,
  AuthorizedConsentersListViewController,
  AuthorizedConsenterEditViewController,
  AuthorizedConsenterNewViewController,
  DoctorsListViewController,
  DoctorEditViewController,
  DoctorDetailViewController,
  PharmacyListViewController,
  PharmacyDetailViewController,
  PulseConsultationPhotoModalViewController,
  MedicalHistoryViewController,
  SearchMedicationViewController,
  AddMedicationViewController,
  ConsultationListViewController,
  ConsultationDetailViewController,
  SectionedListViewController,
  DoctorNewViewController,
  NewPharmacyViewController,
  SearchAllergyViewController,
  AddAllergyViewController,
  ImagesListViewController,
  MessageCenterReplyViewController,
  MessageCenterBhScheduleViewController,
  AccountInvoicesListViewController,
  ListViewController,
  FilesListViewController,
  TemplatedListViewController,
  RecoverUsernameViewController,
  ForgotPasswordViewController,
  PliMembersViewController,
  PharmacyMapTemplatedViewController,
  MyPharmaciesViewController,
  PharmacySearchV2ViewController,
  SecureYourAccountViewController,
  UploadImagesViewController,
  VisitMhMinorConsentViewController,
  VisitUscStudyAttestationViewController,
  PreferredPharmacySearchViewController,
  PharmacyResultTypesViewController,
  ActivationAccountViewController,
  MinorMhIntakeCustomViewController,
  SigninSecurityPreferencesViewController,
  FamilyViewController,
  SetHighBloodSugarThresholdViewController,
  SetLowBloodSugarThresholdViewController,
  EmergencyContactViewController,
  LowBloodSugarThresholdViewController,
  HighBloodSugarThresholdViewController,
  DoNotDisturbHoursViewController
};
